import { OnInit, Component, HostListener } from '@angular/core';

@Component({
    selector: 'da-progress-bar',
    templateUrl: './da-progress-bar.component.html'
})
export class DAProgressBarComponent implements OnInit {

    selectedValue: any;

    ngOnInit() {
        this.selectedValue = 0;
    }

    @HostListener('window:progressChange', ['$event'])
    onProgressChange(event: any) {
        if (event.detail) {
            this.selectedValue = event.detail;
        }
    }
}
